import styled from 'styled-components';

export const DestinationCalOuter = styled.div`
  & .dateTag {
    background: #2276e3;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    text-align: center;
    font-size: 10px;
    color: #fff;
    font-weight: 700;
    padding: 3px 7px;
    transition: 0.1s ease-in-out padding 0.05s;
    position: relative;
    z-index: 12;
  }

  & .destCal {
    display: none;
  }
  &:hover .destCal {
    display: block;
  }
  &:hover .dateTag {
    padding: 10px 7px;
    border-radius: 0px 4px 4px 0px;
  }
  &:hover + .overlay {
    display: block;
  }
`;

export const Overlay = styled.p`
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 11;
  display: none;
`;

export const CalendarSection = styled.div`
  width: 332px;
  height: 700px;
  position: absolute;
  right: 86px;
  top: -10px;
  z-index: 12;
  background: #fff;
`;

export const CalSecHead = styled.ul`
  display: flex;
  list-style-type: none;
  margin-top: 3rem;
  padding: 5px 0;
  color: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 1px 2px #ddd;
  & li {
    width: 46px;
    text-align: center;
    padding: 10px 0;
    margin-right: 1px;
  }
`;

export const CalSecContent = styled.div`
  padding: 0px;
  height: 620px;
  overflow-y: auto;
`;

export const CalBlock = styled.div`
  margin-bottom: 30px;
  & .monthlyPrice {
    position: absolute;
    width: 140px;
    text-align: left;
    right: 0px;
    color: #000000;
    padding-left: 15px;
    &.cheapestTag {
      background: #18a160;
      color: #fff;
      &:before {
        width: 0;
        height: 0;
        border-top: 9px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 7px solid #fff;
        content: '';
        position: absolute;
        left: 0px;
        top: 0px;
      }
    }
  }
  &:last-child {
    margin: 0px;
  }
  & ul {
    padding: 0px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    list-style-type: none;
    font-size: 10px;
  }
  & li {
    padding: 7px 0;
    width: 46px;
    background: #f6f6f6;
    margin-right: 1px;
    margin-bottom: 1px;
    cursor: pointer;
    & .calDaytext {
      color: rgba(0, 0, 0, 0.5);
    }
    & .calPricetext {
      color: rgba(0, 0, 0, 0.5);
    }
    &:hover {
      background: #fff;
      box-shadow: 0px 0px 5px #ddd;
    }
    &:hover .calDaytext,
    &:hover .calPricetext {
      color: #000;
      font-weight: 700;
    }
    &.lowestFare {
      background: rgba(24, 161, 96, 0.05);
      & .calPricetext {
        color: #18a160;
        font-weight: 700;
      }
    }
    &.preselected {
      background: #18a160;
      & .calDaytext {
        color: #fff;
        font-weight: 700;
      }
      & .calPricetext {
        color: #fff;
        font-weight: 700;
      }
    }
    &.disabled {
      opacity: 0.2;
      pointer-events: none;
    }
    &.active {
      background: #0b69e3;
      & .calDaytext {
        color: #fff;
        font-weight: 700;
      }
      & .calPricetext {
        color: #fff;
        font-weight: 700;
      }
    }
  }
`;
